import {createReducer} from '@reduxjs/toolkit'
import {
    dCategoriesAddItemAC,
    dCategoriesCheckedAllItemAC,
    dCategoriesCheckedItemAC,
    dCategoriesClearFiltersAC,
    dCategoriesDeleteItemAC,
    dCategoriesEditItemAC,
    dCategoriesSetDataAC,
    dCategoriesSetDetailItemAC,
    dCategoriesSetFiltersAC, dCategoriesSetItemsForPageAC, dCategoriesSetPageNumberAC, dCategoriesSetPaginationAC
} from './dCategoriesActionCreators'
import {typePagination} from "../system/constants";
import {logoutAC, resetReducers} from 'model/system/systemActionCreators';


// Type
export type IdCategoriesStateDataItem = {
    checked?: boolean,
    id: string,
    name: string,
    active?: boolean,
    deleted: boolean
}

export type typeCategoriesFilters = {
    name?: string | null,
    deleted?: boolean | null
}

export type IdCategoriesState = {
    pagination: typePagination,
    data: IdCategoriesStateDataItem[],
    detailItem: IdCategoriesStateDataItem | undefined,
    filters: typeCategoriesFilters
}

// Clean filter object
export const cleanFilterObject: typeCategoriesFilters = {
    name: null,
    deleted: false,
}

// Init state
export const initialState: IdCategoriesState = {
    pagination: {
        pageNumber: 0,
        itemsPerPage: 14,
    },
    data: [],
    detailItem: undefined,
    filters: cleanFilterObject
}


// Reducer
export const DCategoriesReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dCategoriesSetDataAC, (state, action) => {
            state.data = action.payload
        })
        // Reducer of set pagination
        .addCase(dCategoriesSetPaginationAC, (state, action) => {
            state.pagination = {...state.pagination, ...action.payload.pagination}
        })

        // Reducer of set items for page pagination
        .addCase(dCategoriesSetItemsForPageAC, (state, action) => {
            state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
        })

        // Reducer of set pageNumber pagination
        .addCase(dCategoriesSetPageNumberAC, (state, action) => {
            state.pagination.pageNumber = action.payload.pageNumber
        })
        // Reducer of set detail item
        .addCase(dCategoriesSetDetailItemAC, (state, action) => {
            state.detailItem = state.data.find((item) => item.id === action.payload)
        })

        // Reducer of set item in data
        .addCase(dCategoriesEditItemAC, (state, action) => {
            state.data = state.data.map((item) => {
                if (item.id === action.payload.id) {
                    return action.payload
                } else {
                    return item
                }
            })
        })

        // Reducer of add item in data
        .addCase(dCategoriesAddItemAC, (state, action) => {
            state.data.push(action.payload)
        })

        // Reducer of delete item
        .addCase(dCategoriesDeleteItemAC, (state, action) => {
            state.data = state.data.filter((item) => item.id !== action.payload)
        })

        // Reducer of clear filtersForm
        .addCase(dCategoriesClearFiltersAC, (state) => {
            state.filters = {
                deleted: false,
            }
        })

        // Reducer of set filtersForm
        .addCase(dCategoriesSetFiltersAC, (state, action) => {
            state.filters = {...state.filters, ...action.payload}
            state.pagination.pageNumber=0
        })

        // Reducer of set checked item
        .addCase(dCategoriesCheckedItemAC, (state, action) => {
            state.data = state.data.map(item => {
                if (item.id === action.payload) {
                    const newItem = item
                    newItem.checked = !item.checked
                    return newItem
                } else {
                    return item
                }
            })
        })

        // Reducer of set checked all items
        .addCase(dCategoriesCheckedAllItemAC, (state, action) => {
            state.data = state.data.map(item => {
                const newItem = item
                newItem.checked = action.payload
                return newItem
            })
        })
        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailItem=initialState.detailItem
            state.filters = initialState.filters
            state.pagination = initialState.pagination
        })

        .addCase(resetReducers, (state, action) => {
            if (action.payload !== "categories") {
                state.data = initialState.data
                state.detailItem=initialState.detailItem
                state.filters = initialState.filters
                state.pagination = initialState.pagination
            }
        });
})
